<template>
  <div class="col-md-6 order-md-1">
    <h3 class="mb-4">
      Congrats! Your user was created, please fill your contact details.
    </h3>
    <form class="needs-validation">
      <!--    <div class="row">-->
      <!--      <div class="col-md-6 mb-3">-->
      <!--        <label for="firstName">First name</label>-->
      <!--        <input type="text" class="form-control" id="firstName" placeholder="" value="" required>-->
      <!--        <div class="invalid-feedback">-->
      <!--          Valid first name is required.-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="col-md-6 mb-3">-->
      <!--        <label for="lastName">Last name</label>-->
      <!--        <input type="text" class="form-control" id="lastName" placeholder="" value="" required>-->
      <!--        <div class="invalid-feedback">-->
      <!--          Valid last name is required.-->
      <!--        </div>-->
      <!--      </div>-->
      <!--    </div>-->

      <!--    <div class="mb-3">-->
      <!--      <label for="email">Email <span class="text-muted">(Optional)</span></label>-->
      <!--      <input type="email" class="form-control" id="email" placeholder="you@example.com">-->
      <!--      <div class="invalid-feedback">-->
      <!--        Please enter a valid email address for shipping updates.-->
      <!--      </div>-->
      <!--    </div>-->
      <div class="mb-3">
        <label for="address">Address</label>
        <input
          id="address"
          v-model="address"
          type="text"
          class="form-control"
          placeholder="1234 Main St"
          required
        >
        <div class="invalid-feedback">
          Please enter your shipping address.
        </div>
      </div>

      <div class="mb-3">
        <label for="address2">Address 2 <span class="text-muted">(Optional)</span></label>
        <input
          id="address2"
          type="text"
          class="form-control"
          placeholder="Apartment or suite"
        >
      </div>

      <div class="row">
        <div class="col-md-5 mb-3">
          <label for="country">Country</label>
          <select
            id="country"
            v-model="country"
            class="custom-select d-block w-100"
            required
          >
            <option value="">
              Choose...
            </option>
            <option>Canada</option>
            <option>United States</option>
          </select>
          <div class="invalid-feedback">
            Please select a valid country.
          </div>
        </div>
        <div class="col-md-4 mb-3">
          <label for="state">State or province</label>
          <input
            id="province"
            v-model="province"
            type="text"
            class="form-control"
            placeholder=""
            required
          >
          <div class="invalid-feedback">
            Please provide a valid state or province.
          </div>
        </div>

        <div class="col-md-3 mb-3">
          <label for="city">City</label>
          <input
            id="city"
            v-model="city"
            type="text"
            class="form-control"
            placeholder=""
            required
          >
          <div class="invalid-feedback">
            Please provide a valid city.
          </div>
        </div>

        <div class="col-md-3 mb-3">
          <label for="zip">Zip</label>
          <input
            id="zip_code"
            v-model="zip_code"
            type="text"
            class="form-control"
            placeholder=""
            required
          >
          <div class="invalid-feedback">
            Zip code required.
          </div>
        </div>

        <div class="col-md-3 mb-3">
          <label for="employment">Employment</label>
          <input
            id="employment"
            v-model="employment"
            type="text"
            class="form-control"
            placeholder=""
            required
          >
          <div class="invalid-feedback">
            Employment required.
          </div>
        </div>

        <div class="mb-3">
          <label for="phone">Phone number</label>
          <input
            id="phone"
            v-model="phone_number"
            type="tel"
            class="form-control"
            required
          >
          <div class="invalid-feedback">
            Please enter phone number.
          </div>
        </div>
      </div>

      <hr class="mb-4">
      <b-col class="text-center">
        <p v-if="errors.length">
          <br>

            <b>Please correct the following error(s):</b>
            <span style="color: red">
              <li v-for="error in errors">{{ error }}</li>
          </span>

          </p>
      </b-col>
      <button
        type="button"
        class="btn btn-custom theme-color"
        @click="checkForm()"
      >
        Apply
      </button>
    </form>
  </div>
</template>
<script>
/* eslint-disable camelcase */

export default {
  name: 'Detailsform',
  data() {
    return {
      errors: [],
      phone_number: null,
      address: null,
      country: null,
      city: null,
      zip_code: null,
      province: null,
      employment: null,
    }
  },
  computed: {
    askedAmount() {
      return this.$store.state.userData.loanRequested
    },
  },
  methods: {
      checkForm: function (e) {
        this.errors = [];
        if (!this.phone_number) {
          this.errors.push("Phone number required.");
        }
        if (!this.address) {
          this.errors.push("Address required.");
        }
        if (!this.country) {
          this.errors.push("Country required.");
        }
        if (!this.city) {
          this.errors.push("City required.");
        }
        if (!this.zip_code) {
          this.errors.push("Zip code required.");
        }
        if (!this.province) {
          this.errors.push("Province required.");
        }
        if (!this.employment) {
          this.errors.push("Employment required.");
        }
        if (!this.errors.length) {
      const id = localStorage.getItem('user-id')
      const token = localStorage.getItem('user-token')
      const updateUserPromise = this.axios.put(
        `${process.env.ROOT_API}/user/${id}`,
        {
          phone_number: this.phone_number,
          address: this.address,
          city: this.city,
          zip_code: this.zip_code,
          province: this.province,
          country: this.country,
          employment: this.employment,
        },
        {
          headers: {
            authorization: `Token ${token}`,
          },
        }
      )

      const {
        year,
        make,
        model,
        trim: trim_level,
        vehicleStyle: vehicle_style,
        vin,
        odometerReading: odometer_reading,
        carDetails: car_details,
        payment: loan_amount,
        paymentFrequency: frequency,
        numberOfPayments: number_of_payments,
        paymentTotal: payment_total,
        boundaryAmount: boundary_amount,
        approvedLoanAmount: max_loan_amount,
        loanRequested: loan_requested,
        repairOfferAmount: repair_offer_amount,
        cashBack: cash_back,
        vendor,
        term,
      } = this.$store.state.userData

      const createLoanPromise = this.axios.post(
        `${process.env.ROOT_API}/user/loan/create`,
        {
          make,
          model,
          year,
          trim_level,
          vin,
          car_details,
          vehicle_style,
          odometer_reading,
          loan_amount,
          frequency,
          number_of_payments,
          payment_total,
          boundary_amount,
          max_loan_amount,
          loan_requested,
          repair_offer_amount,
          cash_back,
          term,
          vendor: vendor || localStorage.getItem('vendor'),
        },
        {
          headers: {
            authorization: `Token ${token}`,
          },
        }
      )

      Promise.all([updateUserPromise, createLoanPromise]).then(() => {
        location.href = `${process.env.DASHBOARD_URL}/#/login?token=${token}`
      })
      e.preventDefault();
}
  },
    enableForm() {
      if (!this.phone_number || !this.address) {
        return false
      }
      if (!this.city || !this.zip_code || !this.province) {
        return false
      }
      return !(!this.country || !this.employment)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/details_form.vue